import Icon from 'veui/components/Icon'
import { IconExpand } from 'dls-icons-vue'

Icon.register('expand', IconExpand)
